import Markdown, { MarkdownToJSX } from 'markdown-to-jsx';
import { Typography, TypographyOwnProps } from '@mui/material';

import { useMarkdownWrapperStyles } from './useMarkdownWrapperStyles';

export interface MarkdownWrapperProps {
  children: string;
  olVariant?: TypographyOwnProps['variant'];
  options?: MarkdownToJSX.Options;
  ulVariant?: TypographyOwnProps['variant'];
}

export const MarkdownWrapper = ({
  children,
  olVariant = 'body2',
  options,
  ulVariant = 'body2',
  ...rest
}: MarkdownWrapperProps) => {
  const { classes } = useMarkdownWrapperStyles();

  return (
    <Markdown
      {...rest}
      options={{
        ...options,
        overrides: {
          ...options?.overrides,
          ol: {
            component: Typography,
            props: {
              className: classes.ol,
              component: 'ol',
              variant: olVariant,
            },
          },
          p: {
            component: 'p',
            props: {
              className: classes.p,
            },
          },
          ul: {
            component: Typography,
            props: {
              className: classes.ul,
              component: 'ul',
              variant: ulVariant,
            },
          },
        },
      }}
    >
      {children}
    </Markdown>
  );
};
